import { Glyph } from "./glyphs";
import type { Source } from "./sourceOf";

/** Where he asked from, in the meta line under his bubble: a 13 px glyph and
 *  the word (spec 2026-09-24 §1). The caller renders nothing for an unknown
 *  source (sourceOf returns null), never a guess. */
export function SourceMark({ source }: { source: Source }) {
  return (
    <span className="inline-flex items-center gap-1" data-source={source.glyph}>
      <Glyph
        name={source.glyph}
        strokeWidth={1.35}
        className="size-[13px] text-fg-subtle"
      />
      {source.label}
    </span>
  );
}
